import React, { useState, useEffect, useRef } from "react";
import { Row, Button, Col, Checkbox, Card, Input, Space, Typography, Drawer, Form } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import RetailModal from "../Retail/RetailModals";
import db from "../../../database";
import Calender from "../../../assets/images/calender.svg";
import Close from "../../../assets/images/close-x.svg";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import userIcon from "../../../assets/images/userId.svg";
import CashGif from "../../../assets/images/cashGif.gif";
const CashManagement = (props) => {
  const { Text, Title } = Typography;
  const {
    setAddCashFlag,
    setCashAddInFlag,
    handleCahInOut,
    cashAddInFlag,
    addCashFlag,
    posConfig,
    onChangeCheckbox,
    width,
    cashManagementForm,
    cashIn,
    pettCashIn,
    userPreferences,
  } = props;
  const currentDateTime = useState(moment(new Date()).format(userPreferences.dateFormat));
  const [cashInData, setCashInData] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));

  const handleCashManagement = (value) => {
    let formData = cashManagementForm.getFieldsValue(true);

    if (formData.amount === "" && value === "x") {
      cashManagementForm.setFieldsValue({
        amount: "",
      });
    } else if (value === "x") {
      cashManagementForm.setFieldsValue({
        amount: `${formData.amount.toString().substring(0, formData.amount.toString().length - 1)}`,
      });
    } else {
      cashManagementForm.setFieldsValue({
        amount: `${formData.amount ? formData.amount : ""}${value}`,
      });
    }
  };

  const handleCashInNote = (value) => {
    cashManagementForm.setFieldsValue({
      note: value,
    });
  };

  useEffect(() => {
    db.cashInCashOut.toArray().then((res) => {
      setCashInData(res);
    });
  }, [cashInData]);
  const handleClear = () => {
    cashManagementForm.setFieldsValue({ amount: "" });
  };

  return (
    <div style={{ padding: "2vh 1.5vw", position: "relative", height: "100vh" }}>
      {/* <RetailModal {...props} /> */}
      <Row>
        <Col span={8} offset={16} style={{ textAlign: "right", fontSize: "1vw" }}>
          <img src={userIcon} style={{ height: "2.7vh", paddingBottom: "0.3em", paddingRight: "0.5vw" }} />
          <span style={{ paddingRight: "1vw", fontWeight: 500, fontSize: "1.25em", color: "#0F0718", marginBottom: 0 }}>{userData.user}</span>
          <img src={Calender} style={{ height: "3.5vh", paddingRight: "0.5vw", paddingBottom: "0.3em" }} />
          <span style={{ fontSize: "1.25em", color: "#929098", fontWeight: "500" }}>{currentDateTime}</span>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ paddingTop: "4vh" }}>
        {cashInData.map((recordData) => {
          return (
            <Col span={8}>
              <Card style={{ height: "14vh", width: "100%", borderRadius: "10px", padding: "2vh 1.3vw", fontSize: "1vw" }}>
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text style={{ fontSize: "1.25em", fontWeight: "600", color: "#0F0718" }}>{recordData.note}</Text>
                  <Text style={{ fontSize: "1.25em", fontWeight: "600", color: "#0F0718" }}>{recordData.type}</Text>
                </Space>
                <Space style={{ width: "100%", justifyContent: "space-between", paddingTop: "2vh" }}>
                  <Text style={{ fontSize: "1em", fontWeight: "500", color: "#0F0718" }}>{recordData.date}</Text>
                  <Text style={{ fontSize: "1.25em", fontWeight: "600", color: "#0F0718" }}>{recordData.amount}</Text>
                </Space>
              </Card>
            </Col>
          );
        })}
      </Row>

      {cashInData.length <= 0 ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            right: "1.3vw",
            width: "100%",
            marginTop: "15vh",
            textAlign: "right",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <img
              src={CashGif}
              alt="Cash Drawer Animation"
              style={{
                width: "150px",
                height: "auto",
                marginBottom: "2vh",
              }}
            />
            <div
              style={{
                marginBottom: "3vh",
                fontSize: "1vw",
                fontWeight: "600",
                color: "#0F0718",
                textAlign: "center",
              }}
            >
              {getMultilingualText("Add or Remove Cash from the Cash Drawer")}
            </div>

            <Space direction="horizontal" style={{ fontSize: "1vw" }}>
              <Button
                onClick={() => {
                  setAddCashFlag(true);
                  setCashAddInFlag(true);
                }}
                style={{
                  height: "6vh",
                  backgroundColor: "#2F3856",
                  color: "#fff",
                  minWidth: "11vw",
                  borderRadius: "10px",
                  fontSize: "1em",
                  fontWeight: "500",
                }}
              >
                {getMultilingualText("Remove Cash")}
              </Button>
              <Button
                onClick={() => {
                  setAddCashFlag(true);
                  setCashAddInFlag(false);
                }}
                style={{
                  height: "6vh",
                  backgroundColor: "#2F3856",
                  color: "#fff",
                  minWidth: "11vw",
                  borderRadius: "10px",
                  fontSize: "1em",
                  fontWeight: "500",
                }}
              >
                {getMultilingualText("Add Cash")}
              </Button>
            </Space>
          </div>
        </div>
      ) : (
        <div>
          <Space direction="horizontal" style={{ position: "absolute", right: "1.3vw", bottom: "2vh", fontSize: "1vw" }}>
            <Button
              onClick={() => {
                setAddCashFlag(true);
                setCashAddInFlag(true);
              }}
              style={{
                height: "6vh",
                backgroundColor: "#2F3856",
                color: "#fff",
                minWidth: "11vw",
                borderRadius: "10px",
                fontSize: "1em",
                fontWeight: "500",
              }}
            >
              {getMultilingualText("Remove Cash")}
            </Button>
            <Button
              onClick={() => {
                setAddCashFlag(true);
                setCashAddInFlag(false);
              }}
              style={{
                height: "6vh",
                backgroundColor: "#2F3856",
                color: "#fff",
                minWidth: "11vw",
                borderRadius: "10px",
                fontSize: "1em",
                fontWeight: "500",
              }}
            >
              {getMultilingualText("Add Cash")}
            </Button>
          </Space>
        </div>
      )}
    </div>
  );
};

export default CashManagement;
